export { default as Img200 } from './processed/200/redzel.jpg';
export { default as Img400 } from './processed/400/redzel.jpg';
export { default as Img600 } from './processed/600/redzel.jpg';
export { default as Imgthumb } from './processed/thumb/redzel.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/redzel.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/redzel.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      223,
      65,
      66
    ],
    "_population": 579,
    "_hsl": [
      0.9989451476793249,
      0.7117117117117118,
      0.5647058823529412
    ]
  },
  "LightVibrant": {
    "_rgb": [
      239,
      130,
      126
    ],
    "_population": 2014,
    "_hsl": [
      0.005899705014749242,
      0.7793103448275862,
      0.7156862745098039
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      104,
      104,
      47
    ],
    "_population": 124,
    "_hsl": [
      0.16666666666666666,
      0.37748344370860926,
      0.296078431372549
    ]
  },
  "Muted": {
    "_rgb": [
      172,
      182,
      105
    ],
    "_population": 2587,
    "_hsl": [
      0.1883116883116883,
      0.3452914798206279,
      0.5627450980392157
    ]
  },
  "LightMuted": {
    "_rgb": [
      179,
      214,
      207
    ],
    "_population": 710,
    "_hsl": [
      0.4666666666666666,
      0.29914529914529936,
      0.7705882352941176
    ]
  },
  "DarkMuted": {
    "_rgb": [
      100,
      59,
      49
    ],
    "_population": 2533,
    "_hsl": [
      0.032679738562091505,
      0.3422818791946308,
      0.29215686274509806
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/redzel.js